import React from 'react';
import BoFormProvider from "./context/bo-form-context.jsx";
import BoForm from "./bo-form.jsx";

const BoFormIndex = () => {
    return (
        <BoFormProvider>
            <BoForm />
        </BoFormProvider>
    );
};

export default BoFormIndex;